<template>
  <div class="app-bank-account">
    <div class="inputs-container">
      <div class="input-field">
        <label class="text-base-medium">Kontoinhaber</label>
        <span class="text-base">{{ customer.firstName + ' ' + customer.lastName }}</span>
      </div>
      <div class="input-field">
        <label class="text-base-medium flex-align-center">IBAN<span class="required" aria-hidden="true">*</span></label>
        <ValidationIndicator :dirty="$v.inputIban.$dirty" :valid="isValid('inputIban')">
          <input
            type="text"
            class="input"
            placeholder="IBAN"
            id="iban-group"
            name="iban"
            v-model="inputIban"
            required
            @blur="$v.inputIban.$touch"
            @click="$v.inputIban.$reset"
            :class="{
              'input--invalid': $v.inputIban.$invalid && $v.inputIban.$dirty,
              'input--valid': !$v.inputIban.$invalid && $v.inputIban.$dirty
            }"
          />
        </ValidationIndicator>
        <p v-show="$v.inputIban.$invalid && $v.inputIban.$dirty" class="text-error">
          Bitte gebe eine IBAN ein
        </p>
      </div>
      <div class="checkbox-wrapper">
        <div class="checkbox-element">
          <div class="checkbox-field">
            <input
              type="checkbox"
              name="AGB"
              value="consent"
              id="payment-confirmation-group"
              v-model="inputPaymentConfirmation"
              required
              class="custom-checkbox manda"
              @input="$v.inputPaymentConfirmation.$touch"
            />
          </div>
        </div>
        <p>
          Ich ermächtige/Wir ermächtigen die Vodafone
          <abbr title="Gesellschaft mit beschränkter Haftung">GmbH</abbr>
          (Gläubiger-ID: DE26ZZZ00000006194), Zahlungen von meinem/unserem Konto mittels Lastschrift einzuziehen. Zugleich weise
          ich mein/weisen wir unser Kreditinstitut an, die von der Vodafone GmbH auf mein/unser Konto gezogenen Lastschriften
          einzulösen. Hinweis: Ich kann/Wir können innerhalb von acht Wochen, beginnend mit dem Belastungsdatum, die Erstattung
          des belasteten Betrages verlangen. Es gelten dabei die mit meinem/unserem Kreditinstitut vereinbarten Bedingungen.
        </p>
      </div>
      <p v-show="$v.inputPaymentConfirmation.$invalid && $v.inputPaymentConfirmation.$dirty" class="text-error">
        Bitte stimme den AGBs zu
      </p>
      <div v-if="isPUC && isValid('inputPaymentConfirmation')" class="txtPaymentConfirmationDescription">
        <div v-for="term in brandConsents.consents" :key="term.text">
          <p v-html="term.text"></p>
        </div>
      </div>
      <div class="inputs-container"></div>
    </div>
  </div>
</template>

<script>
import { wrapQuery } from '@/helper/wrapGQLQuery'
import gql from 'graphql-tag'
import { validationMixin } from 'vuelidate'
import isValid from '@/mixins/isValid'
import { required, sameAs } from 'vuelidate/lib/validators'
import syncProperty from '@/mixins/syncProperty'
import ibanValidator from '@/mixins/ibanValidator'
import ValidationIndicator from '../../../generic/ValidationIndicator.vue'

export default {
  name: 'EnterBankAccountData',
  components: { ValidationIndicator },
  data() {
    return {
      brandConsents: {
        consents: [
          {
            text: ''
          }
        ]
      },
      brand: ''
    }
  },
  watch: {
    '$v.$invalid': function(newValue) {
      this.$emit('update:invalid', newValue)
    }
  },
  methods: {
    markInputAsDirty() {
      this.$v.inputIban.$touch()
      this.$v.inputPaymentConfirmation.$touch()
    }
  },
  computed: {
    inputOwner() {
      return this.customer.firstName + ' ' + this.customer.lastName
    }
  },
  mixins: [
    ibanValidator,
    validationMixin,
    isValid,
    syncProperty('iban', 'inputIban'),
    syncProperty('owner', 'inputOwner'),
    syncProperty('paymentConfirmation', 'inputPaymentConfirmation')
  ],
  props: {
    isPUC: {
      type: Boolean
    },
    filterKeys: {
      type: String,
      default: 'privilege_terms'
    },
    customer: {
      type: Object
    },
    displayConfirmationError: {
      type: Boolean
    }
  },
  validations() {
    return {
      /** inputOwner: {
        required
      }, **/
      inputIban: {
        required,
        validateIban: this.$config?.validation?.validateIban
      },
      inputPaymentConfirmation: {
        sameAs: sameAs(() => true)
      }
    }
  },
  apollo: {
    brandConsents: function() {
      const query = wrapQuery(
        gql`
          query prevTerms($brand: String!, $filterKeys: [String!]) {
            brandConsents(brand: $brand, filterKeys: $filterKeys) {
              consents {
                text
              }
            }
          }
        `,
        this,
        'brandConsents',
        {
          brand: this.$store.getters.brand,
          filterKeys: this.filterKeys
        }
      )
      return query
    }
  }
}
</script>
